export default "__VITE_ASSET__LMA36JfY__"